/**
 * Centralized route constants for the frontend-main application.
 * Use these constants instead of hardcoding route strings throughout the app.
 */

export const ROUTES = {
  // Layout prefix
  EMPRESA_LAYOUT: '/empresa',

  // Main routes
  HOME: '/empresa/home',
  EMPRESAS: '/empresa/empresas',
  NUEVA_EMPRESA: '/empresa/nueva',
  IMPORT_EMPRESA: '/empresa/import/new',
  MIS_IMPORTS: '/empresa/imports',
  IMPORT_DETALLE: (importId) => `/empresa/import/${importId}`,
  SOPORTE: '/empresa/soporte',
  CUENTA: '/empresa/cuenta',

  // Company-scoped routes (new)
  COMPANY_DASHBOARD: (companyId) => `/empresa/${companyId}/dashboard`,
  COMPANY_NOTIFICATIONS: (companyId) => `/empresa/${companyId}/notificaciones`,
  COMPANY_DOCUMENTS: (companyId) => `/empresa/${companyId}/documentos`,
  COMPANY_BANKING: (companyId) => `/empresa/${companyId}/banking`,
  COMPANY_TAXES: (companyId) => `/empresa/${companyId}/impuestos`,
  COMPANY_PERKS: (companyId) => `/empresa/${companyId}/perks`,

  // Service routes (placeholders)
  BANCO: '/empresa/banco',
  IMPUESTOS: '/empresa/impuestos',

  // Auth routes
  SIGN_IN: '/auth/sign-in/default',
  SIGN_UP: '/auth/sign-up/default',

  // Public routes
  TERMINOS: '/terminos',
  PRIVACIDAD: '/privacidad',
  BLOG: '/blog',
  BLOG_POST: (slug) => `/blog/${slug}`,

  // Dynamic routes (functions)
  PERFIL_EMPRESA: (registrationId) =>
    `/empresa/empresas/${registrationId}/perfil`,
};

export default ROUTES;
